import { IntegratedRecordsList } from 'components/IntegratedRecordsList';
import { table } from 'console';
import { notification } from 'core/anand.notification';
import { isAdmin, isMobile, timeout } from 'helpers';
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { AnumatiRecord, ApplicationState } from 'types';
import { AnumatiPatra } from './anand.anumatiPatra';
import { AnumatiTable } from './anumatiTable';
import { AnumatiViewTile, anumatiViewTileCSS } from './anumatiViewTile';
import BulkEditDialog from './bulkEdit/BulkEditDialog';
import ImportDialog from './bulkEdit/ImportDialog';
import { downloadCsv, exportFileName, recordsToCsv } from './bulkEdit/importPlan';

let anumatiCSS = `
#selection-dropdown {
	display: none !important;
}
.find-anything {
	display: none;
}
#record_count {
	margin-top: 0;
}

#anumati-detail-record-form {
	display: none;
}

#anumati-add-record {
	display: none;
}

#anumati-add-record-open {
	width: 50%;
	float: left;
	padding: 2em 1em 1em;
	display: none;
}

#add-record-open {
	float: right;
}

#date_wise_count {
	margin: 10px 5px 5px;
	box-shadow: 1px 1px 5px grey;
	display: block;
	overflow: auto;
}

#date_wise_count label.count-filter {
	display: block;
	margin: 0;
	font-weight: inherit;
	cursor: pointer;
	white-space: nowrap;
}

#date_wise_count label.count-filter input[type='checkbox'] {
	width: auto;
	margin: 0 4px 0 0;
	vertical-align: middle;
	cursor: pointer;
}

.checkins-btn {
	display: none;
}

.intl-tel-input {
	width: 100%;
}

.heading {
	text-align: center;
	font-size: 1.2em;
	font-weight: bold;
	margin-bottom: 1.5em;
	border-bottom: 1px solid grey;
	padding-bottom: 0.3em;
	text-transform: uppercase;
}

form.tile .comments {
	width: 100%;
	resize: none;
	height: 9em;
}

.tile .comments {
	border: 1px solid darkgray;
	padding: 10px;
	overflow: auto;
	max-height: 6em;
}

.tile .comments-title {
	border: 1px solid darkgray;
	border-bottom: 0;
	text-align: center;
}

.tt-suggestion:hover {
	color: white;
	background-color: #0097cf;
	cursor: pointer;
}

.through-sugestion {
	padding: 0.7em 2em;
	white-space: nowrap;
}

.tt-menu {
	width: auto;
	overflow-y: auto;
	max-height: 150px;
	box-shadow: 1px 1px 5px 1px grey;
	background-color: white;
	overflow-x: hidden;
}

input[name='subscriber_no_code'] {
	text-transform: uppercase;
}

.tile.anumati-record.detail {
	padding-top: 15px;
}

.tile.anumati-record .main-details {
	padding-right: 30px;
}

.tile.anumati-record .main-details .title {
	text-align: right;
	padding: 0;
	margin-bottom: 15px;
	font-weight: bold;
	font-size: 0.9em;
}

.tile.anumati-record .main-details .value {
	padding-right: 0;
	margin-bottom: 15px;
}

.tile.anumati-record input {
	width: 100%;
	background-color: white !important;
	border: none;
	border-bottom: 1px solid darkgray;
}

.tile.anumati-record input:disabled {
	background-color: #ccc !important;
}

.tile.anumati-record input[type='checkbox'] {
	width: auto;
	margin-right: 5px;
}

.tile.anumati-record .phone-copy-wrap {
	position: relative;
}

.tile.anumati-record .phone-copy-wrap input[name='phone'] {
	padding-right: 32px;
}

.tile.anumati-record .copy-phone-btn {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	padding: 4px 8px;
	background: transparent;
	border: none;
	outline: none;
	color: #337ab7;
	line-height: 1;
	cursor: pointer;
}

.tile.anumati-record .copy-phone-btn:active {
	color: #23527c;
}

.tile.anumati-record input.invalid-phone {
	border-bottom: 1px solid #a94442;
	color: #a94442;
}

.radio,
.checkbox {
	margin-top: 0;
	margin-bottom: 0;
}

.tile.anumati-record input:focus {
	outline: none;
}

.tile.anumati-record .value select {
	width: 100%;
}

.tile.anumati-record .language-value {
	text-transform: capitalize;
}

.edit-allowed .check-in-details {
	display: none;
}

.bootstrap-dialog-message .edit-allowed .check-in-details {
	display: block;
}

/*
.check-in-section, .check-in-details {
	display: none;
}

.bootstrap-dialog-message .check-in-details {
	display: block;
}*/

form.tile.anumati-record .address {
	width: 100%;
	resize: none;
	height: 6em;
}

.tile.anumati-record .address {
	border: 1px solid darkgray;
	padding: 10px;
	overflow: auto;
	max-height: 6em;
}

.tile.anumati-record .comments-title {
	border: 1px solid darkgray;
	border-bottom: 0;
	text-align: center;
}

div.tile.anumati-record .main-details .value {
	border-bottom: 1px solid lightgrey;
	min-height: 1.5em;
	padding-right: 0;
}

div.tile.anumati-record .ref-detail.value {
	text-transform: capitalize;
}

.lb {
	border-bottom: 1px solid lightgrey;
}

.multi-field-row {
	padding-top: 3px;
	padding-bottom: 3px;
	font-size: 14px;
}

.multi-field-row:nth-last-child(1) {
	border-bottom: none;
}

.btn-danger, .btn-warning {
	float: left;
}

table {
	width: 100%;
	font-size: 0.9em;
	max-height: 12em;
}

table,
th,
td {
	border: 1px solid black;
	padding: 3px;
	text-align: center;
}

thead {
	text-align: center;
	font-weight: bold;
}

.reference-suggestion img {
	width: 100%;
	padding: 0 5px;
}

.tt-dropdown-menu {
	top: auto !important;
	bottom: 100% !important;
}

.tt-dropdown-menu-name {
	top: 100% !important;
	bottom: auto !important;
}

.record-sms-button {
	float: right;
}

.print-history {
	max-height: 100px;
	overflow-y: auto;
}

@media (max-width: 991px) {
	#anumati-add-record-open {
		width: 100%;
		margin-left: 0;
		margin-right: 0;
		margin-bottom: 0;
	}

	.check-in-details {
		display: none;
	}
}
`;

let anumatiPrintCSS = `
body {
	background-color: rgba(0, 0, 0, 0);
}

@media print {
	.print-top-div footer {
		page-break-after: always;
	}
}

.print-top-div footer {
	position: absolute;
	bottom: 40px;
	font-weight: bold;
	font-size: 90%;
	padding: 10px 0px;
	right: 40px;
	left: 40px;
	page-break-after: always;
}
/*
.print-record {
	page-break-after: always;	
}*/

.print-top-div footer > div {
	padding: 5px 0;
}

.print-top-div header {
	font-size: 110%;
	text-align: center;
	font-weight: bold;
	width: 100%;
	padding: 40px 0px;
}

.print-top-div {
	background-color: white;
	padding: 0px 40px;
	width: 8.27in;
	position: relative;
	height: 11.69in;
}

.print-top-div .print-top-header {
	font-size: 125%;
	padding: 20px 0px;
	width: 100%;
	text-align: center;
	font-weight: bold;
}

.print-top-div .field {
	padding-top: 30px;
}

.print-top-div .title {
	font-weight: bold;
	font-size: 90%;
	text-align: left;
	padding-right: 0px;
	float: left;
}

.print-top-div .value {
	border-bottom: 1px dotted black;
	display: block;
	overflow: hidden;
	padding-left: 15px;
}

#print-configs #print-preview {
	height: 36em;
}

#mark_printed_records_btn {
	float: right;
}

#send_sms_records_btn {
	float: right;
}
`;

const html = `
<style>
	${anumatiCSS}
	${anumatiPrintCSS}
</style>

<div id="date_wise_count" data-id="${Math.random()}">
	<table>
		<thead>
			<tr>
				<td colspan="13">Date Wise Count</td>
			</tr>
		</thead>
		<tbody>
			<tr id="lables"></tr>
			<tr id="cards"></tr>
			<tr id="values"></tr>
			<tr id="checkins"></tr>
		</tbody>
	</table>
</div>
<div id="page-records">
    <form id="anumati-add-record-open" class="tile anumati-record detail" method="post" action="javascript:void(0);" enctype="multipart/form-data">
		<div class="col-xs-12 main-details">
			<div class="block">
				<div class="row self-detail">
					<div class="title col-xs-2">
						Name:
					</div>
					<div class="value col-xs-10">
						<input type="text"  name="name" value="" required placeholder="Name"/>
					</div>
				</div>
				<div class="row address-detail">
					<div class="title col-xs-2">
						Count:
					</div>
					<div class="value col-xs-10">
						<input type="number" name="people_count" required placeholder="Count"></input>
					</div>
				</div>
				<div class="row date-detail">
					<div class="title col-xs-2">
						Date:
					</div>
					<div class="value col-xs-10">
						<input type="text" class="date" name="permission_date" required placeholder="Date"></input>
					</div>
				</div>
				<div class="row ref-detail">
					<div class="title col-xs-2">
						Ref:
					</div>
					<div class="value col-xs-10">
						<input type="text"  name="reference" value="" required placeholder="Reference"/>
					</div>
				</div>
				<div class="row phone-detail">
					<div class="title col-xs-2">
						Mobile:
					</div>
					<div class="value col-xs-10 phone-copy-wrap">
						<!-- <input type="tel" name="phone_ignore" value=""/> -->
						<input type="text" name="phone" value="" required placeholder="Mobile Number" style="letter-spacing: 5px;"/>
						<button type="button" class="copy-phone-btn" title="Copy mobile number" aria-label="Copy mobile number">
							<span class="glyphicon glyphicon-copy"></span>
						</button>
					</div>
				</div>
				<!-- <div class="row publish-detail">
					<div class="title col-xs-2">
						Publish Date:
					</div>
					<div class="value col-xs-4">
						<input type="text" class="date" name="publishDatePart" placeholder="Publish Date"></input>
					</div>
					<div class="title col-xs-2">
						Publish Time:
					</div>
					<div class="value col-xs-4">
						<input type="text" name="publishTimePart" placeholder="Publish Time"></input>
					</div>
				</div>
				<div class="row expire-detail">
					<div class="title col-xs-2">
						Expire Date:
					</div>
					<div class="value col-xs-4">
						<input type="text" class="date" name="expireDatePart" placeholder="Expire Date"></input>
					</div>
					<div class="title col-xs-2">
						Expire Time:
					</div>
					<div class="value col-xs-4">
						<input type="text" name="expireTimePart" placeholder="Expire Time"></input>
					</div>
				</div> -->
				<button type="submit" id="add-record-open" class="btn-primary btn">ADD</button>
			</div>
		</div>
    </form>
	<div id="anumati-table"></div>
    <form id="anumati-add-record" class="tile anumati-record detail" method="post" action="javascript:void(0);" enctype="multipart/form-data">
		<div class="col-xs-12 main-details">
			<div class="block">
				<div class="row self-detail">
					<div class="title col-xs-3">
						Name:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="name" value="" required placeholder="Name"/>
					</div>
				</div>
				<div class="row address-detail">
					<div class="title col-xs-3">
						Count:
					</div>
					<div class="value col-xs-9">
						<input type="number" name="people_count" required placeholder="Count"></input>
					</div>
				</div>
				<div class="row date-detail">
					<div class="title col-xs-3">
						Date:
					</div>
					<div class="value col-xs-9">
						<input type="text" class="date value" name="permission_date" required placeholder="Date"></input>
					</div>
				</div>
				<div class="row ref-detail">
					<div class="title col-xs-3">
						Ref:
					</div>
					<div class="value col-xs-9">
						<input type="text"  name="reference" value="" required placeholder="Reference"/>
					</div>
					<div class="row phone-detail">
						<div class="title col-xs-2">
							Mobile:
						</div>
						<div class="value col-xs-10 phone-copy-wrap">
							<!-- <input type="tel" name="phone_ignore" value=""/> -->
							<input type="text" name="phone" value="" required placeholder="Mobile Number" />
							<button type="button" class="copy-phone-btn" title="Copy mobile number" aria-label="Copy mobile number">
								<span class="glyphicon glyphicon-copy"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
    </form>
    <div class="records">
        <form id="anumati-detail-record-form" class="tile anumati-record detail" method="post" action="javascript:void(0);" enctype="multipart/form-data">
            <div class="record-id">
                <span></span>
            </div>
			<div class="col-xs-12 main-details">
				<div class="block">
					<div class="row card-detail">
						<div class="title col-xs-3">
							Card No:
						</div>
						<div class="value col-xs-9">
						</div>
					</div>
					<div class="row self-detail">
						<div class="title col-xs-3">
							Name:
						</div>
						<div class="value col-xs-9">
							<input type="text"  name="name" value="" required placeholder="Name"/>
						</div>
					</div>
					<div class="row address-detail">
						<div class="title col-xs-3">
							Count:
						</div>
						<div class="value col-xs-9">
							<input type="number" name="people_count" required placeholder="Count"></input>
						</div>
					</div>
					<div class="row date-detail">
						<div class="title col-xs-3">
							Date:
						</div>
						<div class="value col-xs-9">
							<input type="text" class="date value" name="permission_date" required placeholder="Date"></input>
						</div>
					</div>
					<div class="row ref-detail">
						<div class="title col-xs-3">
							Ref:
						</div>
						<div class="value col-xs-9">
							<input type="text"  name="reference" value="" required placeholder="Reference"/>
						</div>
					</div>
					<div class="row phone-detail">
						<div class="title col-xs-3">
							Mobile:
						</div>
						<div class="value col-xs-9">
							<!-- <input type="tel" name="phone_ignore" value=""/> -->
							<input type="text" name="phone" value="" required placeholder="Mobile Number" />
						</div>
					</div>
					<div class="row publish-detail">
						<div class="title col-xs-3">
							Publish Time:
						</div>
						<div class="value col-xs-9">
							<div class="datetime-field" data-field="publishDateTime"></div>
						</div>
					</div>
					<div class="row expire-detail">
						<div class="title col-xs-3">
							Expire Time:
						</div>
						<div class="value col-xs-9">
							<div class="datetime-field" data-field="expireDateTime"></div>
						</div>
					</div>					
				</div>
			</div>
			<div class="check-in-details">
				<div class='row'>
					<div class='heading'>Check-In Details</div>
				</div>
				<div class="row check-in-info">
					<div class="col-xs-12 main-details">
						<div class="block">
							<div class="row check-in-detail">
								<div id="check-in-row" class="multi-field-row hidden col-xs-12">
									<div class="row">
										<input type="hidden" name="checkin_ids[]" value="" />
										<input type="hidden" name="created_at[]" value="" />
										<div class="hidden value col-xs-1">
											<select name="in_out[]">
												<option value="in">Check-In</option>
												<option value="out">Check-Out</option>
											</select>
										</div>
										<div class="value created_at_date col-xs-3">
											<input type="text" class="date value" disabled value="" placeholder="Date"/>
										</div>
										<div class="value col-xs-3">
											<input type="text"  name="checkin_name[]" value="" placeholder="Name*"/>
										</div>										
										<div class="value col-xs-3">
											<!-- <input type="tel"  name="checkin_phone_ignore[]" value="" placeholder="Mobile*"/> -->
											<input type="text" name="checkin_phone[]" value="" placeholder="Mobile Number" />
										</div>
										<div class="value col-xs-3">
											<input type="text"  name="checkin_city[]" value="" placeholder="City"/>
										</div>
									</div>
									<div class="row">
										<div class="value col-xs-2">
											<input type="number"  name="checkin_count[]" value="" placeholder="Gents"/>
										</div>
										<div class="value col-xs-2">
											<input type="number"  name="checkin_count_ladies[]" value="" placeholder="Ladies"/>
										</div>
										<div class="value col-xs-2">
											<input type="number"  name="checkin_count_minor[]" value="" placeholder="Children"/>
										</div>
										<div class="value col-xs-2">
											<input type="number"  name="checkin_count_infant[]" value="" placeholder="Infant"/>
										</div>
										<div class="value col-xs-3">
											<input type="text"  name="checkin_conveyance[]" value="" placeholder="Conveyance"/>
										</div>
										<button type="button" class="col-xs-1 btn btn-xs btn-primary multi_field_add_btn" data-field-id="check-in-row"><i class="glyphicon glyphicon-plus"></i></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
        </form>
		<div id="anumati-detail-record" class="tile anumati-record detail edit-allowed" style="display: none;">
			<div class="record-id">
				<span></span>
			</div>
			<div class="row">
				<div class="col-xs-12 main-details">
					<div class="block">
						<div class="title col-xs-3">
							Card No:
						</div>
						<div class="value card-detail col-xs-9">
						</div>
						<div class="title col-xs-3">
							Name:
						</div>
						<div class="value self-detail col-xs-9">
						</div>
						<div class="title col-xs-3">
							Count:
						</div>
						<div class="value count-detail col-xs-9">
						</div>
						<div class="title col-xs-3">
							Date:
						</div>
						<div class="value date-detail col-xs-9">
						</div>
						<div class="title col-xs-3">
							Ref:
						</div>
						<div class="value ref-detail col-xs-9">
						</div>
						<div class="title col-xs-3">
							Mobile:
						</div>
						<div class="value phone-detail col-xs-9">
						</div>
						<div class="deleted">
							<div class="title col-xs-3">
								Deleted:
							</div>
							<div class="value deleted-detail col-xs-9">
							</div>
						</div>
						<div class="publish">
							<div class="title col-xs-3">
								Publish Time:
							</div>
							<div class="value publish-time-detail col-xs-9">
							</div>
						</div>
						<div class="expiry">
							<div class="title col-xs-3">
								Expire Time:
							</div>
							<div class="value expire-time-detail col-xs-9">
							</div>
						</div>
					</div>
					<button class="btn-primary btn record-approve-button">Approve</button>
					<button class="btn-primary btn record-print-button">Print</button>
					<button class="btn-primary btn record-ams-button">Send AMS</button>
				</div>
			</div>
			<div class="row check-in-details">
				<div class='col-xs-12'>
					<div class='heading'>Check-In Details</div>
				</div>
				<div class="check-in-info">
					<div class="col-xs-12 main-details">
						<div class="block">
							<div class="row check-in-detail">
								<div id="check-in-data-detail" class="multi-field-row hidden col-xs-12">
									<div class="row">
										<div class="col-xs-6">
											<div class="row">
												<div class="date col-xs-6">
													<input type="text" class="value" disabled value="" placeholder="Date"/>												
												</div>
												<div class="title col-xs-1">
													Name:
												</div>
												<div class="value name col-xs-5">
												</div>
											</div>
										</div>
										<div class="col-xs-6">
											<div class="row">
												<div class="title col-xs-3">
													Count Major & Minor:
												</div>
												<div class="value count col-xs-3">
												</div>										
												<div class="title col-xs-1">
													Mobile:
												</div>
												<div class="value phone col-xs-5">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<button class="btn-primary btn checkins-btn">Check-In/Out</button>
		</div>
        <div class="filtered-records">
        </div>
    </div>
</div>
`;

interface Props {
	records: AnumatiRecord[];
	admin: boolean;
}

const TILE_VIEW_STORAGE_KEY = 'anumati.tileView';
const PINNED_TILES_STORAGE_KEY = 'anumati.pinnedTiles';

function loadPinnedTiles(): { [id: string]: boolean } {
	try {
		let stored = window.localStorage.getItem(PINNED_TILES_STORAGE_KEY);
		if (stored) {
			let parsed = JSON.parse(stored);
			if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
				return parsed;
			}
		}
	} catch (e) {
		// Corrupt or unavailable storage simply means nothing is pinned.
	}

	return {};
}

function savePinnedTiles(pinnedTiles: { [id: string]: boolean }) {
	try {
		window.localStorage.setItem(PINNED_TILES_STORAGE_KEY, JSON.stringify(pinnedTiles));
	} catch (e) {
		// Persisting the preference is best effort.
	}
}

/**
 * Per tile brief/detailed choices are a view preference, so they are kept in
 * localStorage and survive a page refresh. Only tiles that differ from the global
 * mode are stored, which keeps the map small and makes a header toggle a clean reset.
 */
function loadTileView(defaultShowDetailed: boolean): { showDetailed: boolean; tileOverrides: { [id: string]: boolean } } {
	try {
		let stored = window.localStorage.getItem(TILE_VIEW_STORAGE_KEY);
		if (stored) {
			let parsed = JSON.parse(stored);
			return {
				showDetailed: typeof parsed?.showDetailed === 'boolean' ? parsed.showDetailed : defaultShowDetailed,
				tileOverrides: parsed?.tileOverrides && typeof parsed.tileOverrides === 'object' && !Array.isArray(parsed.tileOverrides) ? parsed.tileOverrides : {},
			};
		}
	} catch (e) {
		// Corrupt or unavailable storage falls back to the default view.
	}

	return { showDetailed: defaultShowDetailed, tileOverrides: {} };
}

function saveTileView(showDetailed: boolean, tileOverrides: { [id: string]: boolean }) {
	try {
		window.localStorage.setItem(TILE_VIEW_STORAGE_KEY, JSON.stringify({ showDetailed, tileOverrides }));
	} catch (e) {
		// Persisting the preference is best effort.
	}
}

const VIEW_PREFS_STORAGE_KEY = 'anumati.viewPrefs';

interface ViewPrefs {
	counts: boolean;
	form: boolean;
}

/**
 * Whether the counts panel and the add form are showing. Detailed tiles are already kept
 * with the tile view preference, so the three view menu options all survive a refresh.
 */
function loadViewPrefs(): ViewPrefs {
	// Both have historically been open on load, so that stays the default.
	let defaults: ViewPrefs = { counts: true, form: true };

	try {
		let stored = window.localStorage.getItem(VIEW_PREFS_STORAGE_KEY);
		if (stored) {
			let parsed = JSON.parse(stored);
			return {
				counts: typeof parsed?.counts === 'boolean' ? parsed.counts : defaults.counts,
				form: typeof parsed?.form === 'boolean' ? parsed.form : defaults.form,
			};
		}
	} catch (e) {
		// Corrupt or unavailable storage falls back to the defaults.
	}

	return defaults;
}

function saveViewPrefs(changes: Partial<ViewPrefs>) {
	try {
		window.localStorage.setItem(VIEW_PREFS_STORAGE_KEY, JSON.stringify({ ...loadViewPrefs(), ...changes }));
	} catch (e) {
		// Persisting the preference is best effort.
	}
}

class Component extends React.Component<
	Props,
	{
		dateWiseCountHeight: number;
		formHeight: number;
		showDetailed: boolean;
		tileOverrides: { [id: string]: boolean };
		pinnedTiles: { [id: string]: boolean };
		bulkEditOpen: boolean;
		importOpen: boolean;
	}
> {
	private addFormResizeObserver?: ResizeObserver;

	constructor(props) {
		super(props);

		let tileView = loadTileView(isMobile() ? false : true);

		this.state = {
			dateWiseCountHeight: 0,
			formHeight: -25,
			showDetailed: tileView.showDetailed,
			tileOverrides: tileView.tileOverrides,
			pinnedTiles: loadPinnedTiles(),
			bulkEditOpen: false,
			importOpen: false,
		};
	}

	private togglePinnedTile = (recordId: string) => {
		if (!recordId) {
			return;
		}

		let pinnedTiles = { ...this.state.pinnedTiles };

		if (pinnedTiles[recordId]) {
			delete pinnedTiles[recordId];
		} else {
			pinnedTiles[recordId] = true;
		}

		savePinnedTiles(pinnedTiles);
		// Ordering lives in the records module so the rendered order and the module's
		// record list stay in step, which tile index lookups depend on.
		AnumatiPatra.setPinnedTiles(pinnedTiles);
		this.setState({ pinnedTiles });
	};

	private toggleTileDetailed = (recordId: string) => {
		if (!recordId) {
			return;
		}

		let { showDetailed, tileOverrides } = this.state;
		let nextDetailed = !(tileOverrides[recordId] ?? showDetailed);
		let nextOverrides = { ...tileOverrides };

		if (nextDetailed === showDetailed) {
			delete nextOverrides[recordId];
		} else {
			nextOverrides[recordId] = nextDetailed;
		}

		saveTileView(showDetailed, nextOverrides);
		this.setState({ tileOverrides: nextOverrides });
	};


	updateCountHeight = async () => {
		await timeout(100);
		if ($('#date_wise_count').is(':visible') && this.state.dateWiseCountHeight === 0) {
			this.setState({ dateWiseCountHeight: $('#date_wise_count').height() + 15 });
		}

		if (!$('#date_wise_count').is(':visible') && this.state.dateWiseCountHeight > 0) {
			this.setState({ dateWiseCountHeight: 0 });
		}
	};

	private updateFormHeight = () => {
		const form = $('#anumati-add-record-open');
		const formHeight = form.is(':visible') ? Math.ceil(form.outerHeight(true) ?? 0) : -25;
		if (formHeight !== this.state.formHeight) this.setState({ formHeight });
	};

	componentDidMount = async () => {
		$('#date_wise_count').bind('heightChange', this.updateCountHeight);
		const form = document.getElementById('anumati-add-record-open');
		// Autocomplete hints and explicit mobile choices can grow the add form.
		if (form && typeof ResizeObserver !== 'undefined') {
			this.addFormResizeObserver = new ResizeObserver(this.updateFormHeight);
			this.addFormResizeObserver.observe(form);
		}
		window.addEventListener('resize', this.updateFormHeight);
		// Seeds the records module before its first load so pins survive a refresh.
		AnumatiPatra.setPinnedTiles(this.state.pinnedTiles, false);
		// ReactDOM.render(<AnumatiTable />, document.getElementById('anumati-table'));
	};

	componentWillUnmount() {
		this.addFormResizeObserver?.disconnect();
		window.removeEventListener('resize', this.updateFormHeight);
		$('#date_wise_count').off('heightChange', this.updateCountHeight);
		AnumatiPatra.disposeAutocomplete();
	}

	render() {
		let style = {
			width: isMobile() || (!this.props.admin && this.state.formHeight <= 0) ? '100%' : 'calc(50% - 10px)',
			float: 'right',
			height: `calc(100% - ${this.state.dateWiseCountHeight}px - ${isMobile() ? this.state.formHeight : 0}px)`,
		};

		let handlerProps = {
			toggleDetailCount: () => {
				$('#date_wise_count').toggle();
				saveViewPrefs({ counts: $('#date_wise_count').is(':visible') });
				this.updateCountHeight();
			},
			toggleForm: () => {
				$('#anumati-add-record-open').toggle();
				// Read back from the DOM rather than inferring, so the two cannot drift.
				let open = $('#anumati-add-record-open').is(':visible');
				saveViewPrefs({ form: open });
				this.updateFormHeight();
			},
			/** Restores the saved show/hide choices once the header has finished setting up. */
			applyViewPrefs: () => {
				let prefs = loadViewPrefs();
				$('#date_wise_count').toggle(prefs.counts);
				$('#anumati-add-record-open').toggle(prefs.form);
				this.updateFormHeight();
				this.updateCountHeight();
			},
			/**
			 * What the view menu ticks read. Counts and the form are jQuery toggled so the
			 * DOM is their truth, while detailed tiles are React state.
			 */
			getViewState: () => ({
				counts: $('#date_wise_count').is(':visible'),
				form: $('#anumati-add-record-open').is(':visible'),
				detailed: this.state.showDetailed,
			}),
			toggleShowDetailed: () => {
				// The header control is the global switch, so it clears every per tile choice.
				let showDetailed = !this.state.showDetailed;
				saveTileView(showDetailed, {});
				this.setState({ showDetailed, tileOverrides: {} });
			},
			bulkEdit: async () => {
				this.setState({ bulkEditOpen: true });
			},
			exportRecords: async () => {
				let { records } = AnumatiPatra.getBulkEditContext();
				downloadCsv(recordsToCsv(records), exportFileName());
				notification.showBottomNotification(`Exported ${records.length} records`);
			},
			importRecords: async () => {
				this.setState({ importOpen: true });
			},
			RecordTileProps: {
				showDetailed: this.state.showDetailed,
				tileOverrides: this.state.tileOverrides,
				onToggleTileDetailed: this.toggleTileDetailed,
				pinnedTiles: this.state.pinnedTiles,
				onTogglePinnedTile: this.togglePinnedTile,
			},
		};

		let tableStyle = {
			height: `calc(100% - ${this.state.dateWiseCountHeight}px - ${this.state.formHeight}px - 30px)`,
		};

		return (
			<React.Fragment>
				<div dangerouslySetInnerHTML={{ __html: anumatiViewTileCSS }}></div>
				<IntegratedRecordsList
					records={this.props.records}
					RecordTile={AnumatiViewTile}
					html={html}
					RecordsHandler={AnumatiPatra}
					style={style}
					handlerProps={handlerProps}
					// getItemSize={() => (!handlerProps.RecordTileProps.showDetailed ? 100 : 320)}
				/>
				{!isMobile() && this.props.admin && <AnumatiTable style={tableStyle} setRefFilter={AnumatiPatra.setRefFilter} />}
				{/* Bulk edit, export and import are admin only, so the dialogs are not even
				    mounted for anyone else. The header buttons are gated the same way. */}
				{this.props.admin && (
					<>
						<BulkEditDialog
							open={this.state.bulkEditOpen}
							onClose={() => this.setState({ bulkEditOpen: false })}
							getContext={() => AnumatiPatra.getBulkEditContext()}
							onApplied={() => AnumatiPatra.refreshRecords()}
						/>
						<ImportDialog
							open={this.state.importOpen}
							onClose={() => this.setState({ importOpen: false })}
							getContext={() => AnumatiPatra.getBulkEditContext()}
							onApplied={() => AnumatiPatra.refreshRecords()}
						/>
					</>
				)}
			</React.Fragment>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		records: state.dataState.anumati.filtered,
		admin: isAdmin(state.dataState.userStore.userData),
	};
}

export const Anumati = connect(mapStateToProps)(Component);
